import React from "react";
import "./hero.css";

const Hero = ({ imageSrc }) => {
  return <div className="hero" id="hero"></div>;
};

export default Hero;
